import { Group } from 'three'
import { IHandleData } from '../../../../../common-code/interfaces/materials/IHandleData'
import { IHandleModelData } from '../../../../../common-code/interfaces/materials/IHandleModelData'
import { INewHandleData } from './FormHandle'
import { transliterate } from '../utils/transliterate'

export const initialErrors = {
    title: '',
}

export const defaultValues = (item: IHandleData | null): INewHandleData => {
    return item
        ? {
            id: item.id,
            title: item.title,
            models: item.models ? item.models : [],
            isDefault: item.isDefault ? item.isDefault : false,
            disable: item.disable ? item.disable : false,
            image: item.image ? item.image : '',
            vendorCode: item.vendorCode,
            imageNew: null,
            align: item.align ? {...item.align} : undefined,
            aligns: item.aligns ? {...item.aligns} : undefined,
            margin: item.margin ? {...item.margin} : undefined,
            margins: item.margins ? {...item.margins} : undefined,
            location: item.location !== undefined ? item.location : undefined,
            locations: item.locations ? {...item.locations} : undefined,
            horizontalMove: item.horizontalMove !== undefined ? item.horizontalMove : undefined,
            horizontalMoves:  item.horizontalMoves ? {...item.horizontalMoves} : undefined,
        }
        : {
            id: '',
            title: '',
            models: [],
            isDefault: false,
            image: '',
            imageNew: null,
        }
}

export interface INewHandleModelData {
    id: string
    width: string
    height: string
    depth: string
    type: string
    ext: string
    error: string
    object3D?: Group
    file?: File
}

export const initialModel = (
    item: IHandleModelData | null
): INewHandleModelData =>
    item
        ? {
              id: item.id,
              width: item.width.toString(),
              height: item.height.toString(),
              depth: item.depth.toString(),
              type: item.type ? item.type : item.id.replace(/_\d+-\d+-\d+/, ''),
              ext: item.ext,
              error: '',
          }
        : {
              id: '',
              width: '0',
              height: '0',
              depth: '0',
              type: 'default',
              ext: 'glb',
              error: '',
          }
export const createHandleNew = (newHandle: INewHandleData) => {
    const handle: INewHandleData = {
        id: transliterate(newHandle.title),
        title: newHandle.title,
        models: newHandle.models,
    }

    if (newHandle.isDefault) {
        handle.isDefault = newHandle.isDefault
    }
    if (newHandle.imageNew) {
        handle.imageNew = newHandle.imageNew
    } else if (newHandle.image) {
        handle.image = newHandle.image
    }
    if (newHandle.vendorCode && newHandle.vendorCode.length > 0) {
        handle.vendorCode = newHandle.vendorCode;
    }
    if (newHandle.align !== undefined) {
        handle.align = {...newHandle.align};
    }
    if (newHandle.aligns !== undefined) {
        handle.aligns = {...newHandle.aligns};
    }
    if (newHandle.margin !== undefined) {
        handle.margin = {...newHandle.margin};
    }
    if (newHandle.margins !== undefined) {
        handle.margins = {...newHandle.margins};
    }
    if (newHandle.location !== undefined) {
        handle.location = newHandle.location;
    }
    if (newHandle.locations !== undefined) {
        handle.locations = {...newHandle.locations};
    }
    if (newHandle.horizontalMove !== undefined) {
        handle.horizontalMove = newHandle.horizontalMove;
    }
    if (newHandle.horizontalMoves !== undefined) {
        handle.horizontalMoves = newHandle.horizontalMoves;
    }

    return handle
}
export const validateHandle = (newHandle: INewHandleData) => {
    if (!newHandle.title) {
        return 'Поле название ручки не может быть пустым'
    }
    if (newHandle.title.length < 2) {
        return 'Минимальная длина названия ручки от 2-х символов'
    }
    if (newHandle.models.length === 0) {
        return 'Добавте модели ручек'
    }
    return ''
}
